import { motion } from 'framer-motion';

const prizeGroups = [
  {
    title: 'Grand Prix',
    prizes: [
      { name: 'Best Feature Film', amount: '$1,500' },
      { name: 'Best Documentary', amount: '$1,500' },
      { name: 'Best Short Film', amount: '$1,000' },
    ],
  },
  {
    title: 'Craft Awards',
    prizes: [
      { name: 'Best Director', amount: '$500' },
      { name: 'Best Cinematography', amount: '$500' },
      { name: 'Best Lead Actor', amount: '$500' },
      { name: 'Best Supporting Actor', amount: '$500' },
    ],
  },
  {
    title: 'Format Awards',
    prizes: [
      { name: 'Best Scene', amount: '$500' },
      { name: 'Best Vertical Film', amount: '$500' },
      { name: 'Best Animation', amount: '$500' },
      { name: 'Audience Choice', amount: '$500' },
    ],
  },
  {
    title: 'Genre — Features',
    prizes: [
      { name: 'Best Feature Drama', amount: '$500' },
      { name: 'Best Feature Comedy', amount: '$500' },
      { name: 'Best Feature Action', amount: '$500' },
    ],
  },
  {
    title: 'Genre — Shorts',
    prizes: [
      { name: 'Best Short Drama', amount: '$500' },
      { name: 'Best Short Comedy', amount: '$500' },
      { name: 'Best Short Action', amount: '$500' },
    ],
  },
];

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.1,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, ease: 'easeOut' },
  },
};

export default function Prizes() {
  return (
    <section className="bg-dark w-full py-24 px-6">
      <div className="max-w-[1200px] mx-auto">
        {/* Eyebrow */}
        <motion.p
          className="font-mono text-teal uppercase mb-4"
          style={{ fontSize: '0.7rem', letterSpacing: '0.25em' }}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          Awards & Prizes
        </motion.p>

        {/* Title */}
        <motion.h2
          className="font-display text-white leading-none mb-6"
          style={{ fontSize: 'clamp(2.5rem, 5vw, 4rem)' }}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          Every winner gets <span className="gradient-text-gold">cash.</span>
        </motion.h2>

        {/* Body */}
        <motion.p
          className="max-w-[640px] mb-16"
          style={{ color: 'rgba(245,245,240,0.65)', lineHeight: 1.7 }}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          No trophies. No certificates. Minimum $500 cash prize for every category winner, plus
          software prizes from our festival partners.
        </motion.p>

        {/* Prize grid */}
        <motion.div
          className="grid grid-cols-1 md:grid-cols-3 rounded-lg overflow-hidden"
          style={{
            gap: '1px',
            background: 'rgba(255,255,255,0.06)',
          }}
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-50px' }}
        >
          {prizeGroups.map((group) => (
            <motion.div
              key={group.title}
              className="bg-dark p-6"
              variants={itemVariants}
            >
              {/* Group title */}
              <p
                className="font-mono uppercase text-muted pb-3 mb-4"
                style={{
                  fontSize: '0.65rem',
                  letterSpacing: '0.15em',
                  borderBottom: '1px solid rgba(255,255,255,0.06)',
                }}
              >
                {group.title}
              </p>

              {/* Prize rows */}
              <div className="space-y-3">
                {group.prizes.map((prize) => (
                  <div
                    key={prize.name}
                    className="flex items-center justify-between"
                  >
                    <span
                      className="text-light"
                      style={{ fontSize: '0.88rem' }}
                    >
                      {prize.name}
                    </span>
                    <span
                      className="font-mono text-gold"
                      style={{ fontSize: '0.88rem' }}
                    >
                      {prize.amount}
                    </span>
                  </div>
                ))}
              </div>
            </motion.div>
          ))}

          {/* Total Prize Pool card */}
          <motion.div
            className="bg-dark p-6 flex flex-col items-center justify-center text-center"
            style={{
              background: 'linear-gradient(135deg, rgba(212,168,67,0.08), rgba(232,114,28,0.05))',
            }}
            variants={itemVariants}
          >
            <p
              className="font-mono uppercase text-muted mb-3"
              style={{
                fontSize: '0.65rem',
                letterSpacing: '0.15em',
              }}
            >
              Total Prize Pool
            </p>
            <span
              className="font-display gradient-text-gold leading-none"
              style={{ fontSize: '4rem' }}
            >
              $12,000
            </span>
            <p
              className="mt-4"
              style={{
                color: 'rgba(245,245,240,0.5)',
                fontSize: '0.82rem',
                lineHeight: 1.6,
              }}
            >
              Cash + software prizes from our festival partners
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
